var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('elw-enum-select',{attrs:{"size":"mini","enum":_vm.eモニタリング業績予測基準値,"value":_vm.selected},on:{"update:value":function($event){_vm.selected=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }